import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const auditLogSchema = z.object({
  id: z.number(),
  entity: z.string(),
  action: z.string(),
  ref_id: z.string().or(z.number()),
  timestamp: z.string().datetime(),
  user_id: z.number().nullable(),
  payload: z.unknown(),
  display_data: z.unknown().nullable(),
});

export type AuditLog = z.infer<typeof auditLogSchema>;

export const auditLogApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getAuditLogs",
    method: "get",
    path: "/audit_logs/:entity/",
    parameters: [{ name: "ids", type: "Query", schema: z.string().or(z.number().transform(String)).array() }],
    status: 200,
    response: auditLogSchema.array(),
  }).build(),
);
